import React from 'react';
import ImageGallerysummerprogram from '../components/ImageGallerysummerprogram';

const IRCSUMMER = () => {
    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>

                    <ImageGallerysummerprogram />

                    {/* IRC 10 Days WEEKLY */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>IRC SUMMER CAMP</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                                Every year, during the summer vacations, IRC, conducts Summer Camp for boys and girls. The aim of this summer camp is to inculcate in our new generation authentic Aqeedah, Amaal, love for the Sunnah & etiquette of Islamic life through Islamic studies and other beneficial activities.                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default IRCSUMMER;
